import { useState } from 'react';
import { PlusIcon, PencilIcon } from '@heroicons/react/24/outline';
import Card, { CardBody } from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Modal, { ModalBody, ModalFooter } from '@/components/ui/Modal';
import Input from '@/components/ui/Input';
import {
  TableContainer, Table, TableHead, TableBody, TableRow, TableHeaderCell, TableCell,
} from '@/components/ui/Table';

const mockOrgs = [
  { id: 1, name: 'Éditions Kampus', publishers: 3, users: 12, created_at: '2023-06-15' },
  { id: 2, name: 'TechMedia Group', publishers: 2, users: 8, created_at: '2023-08-20' },
  { id: 3, name: 'Audio Publishers Inc', publishers: 4, users: 15, created_at: '2023-09-10' },
];

export default function AdminOrganizationsPage() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Organizations</h1>
          <p className="text-slate-500 mt-1">Manage organizations and their settings</p>
        </div>
        <Button leftIcon={<PlusIcon className="w-4 h-4" />} onClick={() => setShowModal(true)}>
          Add Organization
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-slate-800">{mockOrgs.length}</p>
          <p className="text-sm text-slate-500">Total Organizations</p>
        </CardBody></Card>
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-primary-500">{mockOrgs.reduce((s, o) => s + o.publishers, 0)}</p>
          <p className="text-sm text-slate-500">Total Publishers</p>
        </CardBody></Card>
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-secondary-500">{mockOrgs.reduce((s, o) => s + o.users, 0)}</p>
          <p className="text-sm text-slate-500">Total Users</p>
        </CardBody></Card>
      </div>

      <Card padding="none">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow isHoverable={false}>
                <TableHeaderCell>Organization</TableHeaderCell>
                <TableHeaderCell>Publishers</TableHeaderCell>
                <TableHeaderCell>Users</TableHeaderCell>
                <TableHeaderCell>Created</TableHeaderCell>
                <TableHeaderCell>Actions</TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mockOrgs.map((org) => (
                <TableRow key={org.id}>
                  <TableCell className="font-medium">{org.name}</TableCell>
                  <TableCell>{org.publishers}</TableCell>
                  <TableCell>{org.users}</TableCell>
                  <TableCell className="text-sm text-slate-500">{org.created_at}</TableCell>
                  <TableCell>
                    <Button variant="ghost" size="sm" leftIcon={<PencilIcon className="w-3 h-3" />}>Edit</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title="Add Organization">
        <ModalBody>
          <Input label="Organization Name" placeholder="Enter organization name" />
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button onClick={() => setShowModal(false)}>Create</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

